<template>
  <v-container fluid class="fill-height">
    <v-card class="fill-height idcs-fill-width idcs-main-list back-img">
      <v-card-title>
        <i18n path="title.sheduler" class="text-h4 text-uppercase text-decoration-underline"></i18n>
        <v-spacer></v-spacer>
        <span>
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            v-model="search"
            :label="$t('label.search')"
            clearable
          ></v-text-field>
        </span>
      </v-card-title>
      <v-card-text style="position:relative;">
        <v-btn fab absolute bottom dark @click="d_new=true" color="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-data-table
          class="idcs-main-list transparent"
          :items="tasks"
          :headers="headers"
          :page.sync="currentPage"
          :search="search"
          group-by="status"
          :footer-props="foot_props"
          :no-data-text="$t('label.nodata')"
        >
          <template
            v-slot:item.recipients="{item}"
          >{{item.recipients.items?item.recipients.items.length:0}}</template>
          <template v-slot:group.header="{group,headers,isOpen,toggle}">
            <td
              :colspan="headers.length"
              :class="'text-uppercase white--text group-class '+statcol(group)"
            >
              <v-btn icon @click="toggle">
                <v-icon>{{isOpen?'mdi-minus':'mdi-plus'}}</v-icon>
              </v-btn>
              {{$t('group._'+group)}}
            </td>
          </template>
          <template v-slot:item.action="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon :to="'/task/'+item.idx" color="primary" v-on="on">
                  <v-icon>{{item.status==1?'mdi-alarm-plus':'mdi-eye'}}</v-icon>
                </v-btn>
              </template>
              <i18n path="tooltip.taskopen" />
            </v-tooltip>
          </template>
          <template v-slot:item.created="{item}">{{item.created|dt-time}}</template>
          <template v-slot:item.planed="{item}">
            <v-icon v-if="item.status!=1">mdi-alarm</v-icon>
            {{item.planed|dt-time}}
          </template>
          <template v-slot:item.type="{item}">{{$t('task_types.'+item.type).text}}</template>
          <template v-slot:item.price="{item}">{{item.price|currency}}</template>
          <template v-slot:item.status="{item}">{{$t('status._'+item.status)}}</template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <NewTaskDialog v-model="d_new" />
  </v-container>
</template>

<script>
import { addTarifData } from "@/msgService.js";
import NewTaskDialog from "@/components/NewTaskDialog.vue";
import commonmixin from "@/mixins/commonlist.js";

export default {
  components: {
    NewTaskDialog,
  },
  name: "TasksActive",
  mixins: [commonmixin],
  data() {
    return {
      d_new: false,
      tasks: [],
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
        { text: this.$t("fields.pos"), value: "pos", align: "center" },
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.type"), value: "type", align: "center" },
        { text: this.$t("fields.name"), value: "name" },
        { text: this.$t("fields.list"), value: "list" },
        {
          text: this.$t("fields.recipients"),
          value: "recipients",
          align: "center",
        },
        {
          text: this.$t("fields.count"),
          value: "msgcount",
          align: "center",
        },
        {
          text: this.$t("fields.price"),
          value: "price",
          align: "center",
        },
        { text: this.$t("fields.status"), value: "status", align: "center" },
        { text: this.$t("fields.scheduled"), value: "planed", align: "center" },
      ],
    };
  },
  computed: {},
  methods: {
    statcol(s) {
      if (s == 1) return "warning";
      if (s == 2) return "success";
      if (s == 4) return "error";
      if (s == 5) return "accent";
      return "info";
    },

    create() {},
    loadData() {
      this.$api.getTasksActive().then((response) => {
        response.forEach((task) => {
          addTarifData(task, this.$store.getters["user/tarif"], false);
        });
        this.tasks = response;
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.group-class {
  letter-spacing: 2px;
  font-weight: 600;
}
.back-img {
  background-image: url("../../public/img/sms_send_group_random.svg");
  background-size: 550px;
  background-repeat: initial;
}
</style>